import React, { useCallback, useEffect } from 'react';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { useApi, configApiRef, alertApiRef } from '@backstage/core-plugin-api';
import { makeStyles } from '@material-ui/core';
import { TMNATheme } from 'tmna-theme';
import { insightsApiRef } from '../../api';

const useStyles = makeStyles<TMNATheme>(() => ({
  supersetIframe: {
    width: '100%',
    height: '100%',
    '& > iframe': {
      width: 'inherit',
      height: 'inherit',
      border: 'none'
    },
    overflow: 'hidden'
  },
}));

export const Insights = ({dashboardId}:{dashboardId:string}) => {
  const insightsApi = useApi(insightsApiRef);
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const alertApi = useApi(alertApiRef);

  const embed = useCallback(async () => {
    try {
      const guestToken = await insightsApi.fetchGuestToken(dashboardId);
      console.log('guestToken: ', guestToken);
      const embedDashboardRes = await embedDashboard({
        //id: configApi.getOptionalString('app.insightsDashboardId') as string,
        //id: configApi.getOptionalString('app.insightsDashboardId') as string,
        id: dashboardId,
        supersetDomain: configApi.getOptionalString('app.insightsUrl') as string,
        mountPoint: document.getElementById('insights-container') as HTMLElement,
        fetchGuestToken: () => Promise.resolve(guestToken.token),
        debug: true,
        dashboardUiConfig: {
          // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional)
          hideTitle: true,
          filters: {
            expanded: true,
          },
        },
      });
      console.log('embedDashboardRes: ', embedDashboardRes);
    } catch (e) {
      alertApi.post({
        message: 'Something went wrong, please try again!',
        severity: 'error',
        display: 'transient',
      });
    }
  }, [alertApi, configApi, insightsApi, dashboardId]);

  useEffect(() => {
    if (document.getElementById('insights-container')) {
      embed();
    }
  }, [embed]);

  return <div className={classes.supersetIframe} id="insights-container" />;
};
